import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import CreateDansFundQuestionnaireComponent from '../../../../components/Global/DansFundQuestionnaire/Create';

const CreateDansFundQuestionnaire = (): React.ReactElement => {
  const navigate = useNavigate();

  const handleFinish = () => {
    navigate(`/admin/dans-fund-questionnaire`);
  };

  return (
    <DashboardLayout breadcrumbs={[
      { label: 'Admin', link: '/admin/home' },
      { label: "Dan's Fund Questionnaire", link: '/admin/dans-fund-questionnaire' },
      { label: 'Create' }
    ]}>
      <Grid container
            // spacing={4}
      >
        <Grid item xs={12}>
          <CreateDansFundQuestionnaireComponent handleFinish={handleFinish} />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default CreateDansFundQuestionnaire;
